import { cn } from "@/lib/utils";

export const MessageFrame = ({
  side,
  wide,
  children,
}: {
  side: "user" | "bot";
  wide?: boolean;
  children: React.ReactNode;
}) => (
  <div
    className={cn("flex", side === "user" ? "justify-end" : "justify-start")}
  >
    <div
      className={cn(
        side === "user" ? "max-w-[85%]" : "w-full",
        wide && "w-full",
      )}
    >
      {children}
    </div>
  </div>
);
